var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.183 2.56066C12.7688 1.97487 12.7688 1.02513 12.183 0.43934C11.5972 -0.146447 10.6475 -0.146447 10.0617 0.43934L0.43934 10.0617C-0.146447 10.6475 -0.146447 11.5972 0.43934 12.183L10.0617 21.8054C10.6475 22.3912 11.5972 22.3912 12.183 21.8054C12.7688 21.2196 12.7688 20.2699 12.183 19.6841L3.62132 11.1224L12.183 2.56066Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjE4MyAyLjU2MDY2QzEyLjc2ODggMS45NzQ4NyAxMi43Njg4IDEuMDI1MTMgMTIuMTgzIDAuNDM5MzRDMTEuNTk3MiAtMC4xNDY0NDcgMTAuNjQ3NSAtMC4xNDY0NDcgMTAuMDYxNyAwLjQzOTM0TDAuNDM5MzQgMTAuMDYxN0MtMC4xNDY0NDcgMTAuNjQ3NSAtMC4xNDY0NDcgMTEuNTk3MiAwLjQzOTM0IDEyLjE4M0wxMC4wNjE3IDIxLjgwNTRDMTAuNjQ3NSAyMi4zOTEyIDExLjU5NzIgMjIuMzkxMiAxMi4xODMgMjEuODA1NEMxMi43Njg4IDIxLjIxOTYgMTIuNzY4OCAyMC4yNjk5IDEyLjE4MyAxOS42ODQxTDMuNjIxMzIgMTEuMTIyNEwxMi4xODMgMi41NjA2NloiIC8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };